import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What types of natural stone do you supply for landscaping?",
  answer: "We offer an extensive range of premium natural stone, including ethically sourced Indian Sandstone, Brazilian Slate, Italian Porcelain, and British Yorkstone. Each material is selected for its durability and aesthetic appeal in the UK climate."
}, {
  question: "Do you provide professional installation services?",
  answer: "While we are primarily a specialist supplier, we work closely with a network of accredited landscape professionals. We can recommend expert installers in South London who are experienced with our specific stone and timber products."
}, {
  question: "How do I maintain my new stone patio or driveway?",
  answer: "Maintenance varies by material. Generally, we recommend regular sweeping and an annual deep clean with pH-neutral cleaners. For natural sandstone, we offer specialized sealants that protect against staining while allowing the stone to breathe."
}, {
  question: "Can I view the materials in person before ordering?",
  answer: "Absolutely. We encourage customers to visit our South London showroom to see our full range of paving, decking, and walling. Seeing the textures and colors in natural light helps ensure you choose the perfect match for your garden project."
}, {
  question: "What is your delivery lead time for South London?",
  answer: "For in-stock items, we typically deliver within 3-5 working days across South London. Our specialized fleet includes crane-offload vehicles to ensure your materials are placed safely and conveniently at your project site."
}];
export default function Faqaccordion() {
  return <section data-section-id="257659" id="faqaccordion" className="bg-background text-foreground py-16 md:py-24 flex flex-col items-center justify-center min-h-screen">
      <div className="page-container max-w-4xl w-full">
        <h2 className="font-default text-foreground text-3xl md:text-4xl font-bold mb-8 tracking-tight">
          Frequently Asked Questions
        </h2>

        <Accordion type="single" collapsible className="w-full flex flex-col gap-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="bg-card border border-border rounded-lg px-5 shadow-sm last:border-b">
              <AccordionTrigger className="font-default text-foreground text-lg font-semibold hover:text-primary hover:no-underline py-5 text-left transition-colors">
                <span className="flex items-center gap-4">
                  <span className="flex items-center justify-center w-8 h-8 rounded-md bg-primary/10 text-primary text-sm font-bold">
                    {i + 1}
                  </span>
                  {faq.question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="font-default text-muted-foreground text-base pb-5 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}